export const ENDPOINTS = {
  OAUTH_LOGIN: '/oauth/token',
  FORGOT_PASSWORD: '/password-reset-email',
  CHECK_RESET_PASSWORD_TOKEN: '/check-reset-code',
  RESET_PASSWORD: 'password-reset',
  CHANGE_PASSWORD: '/change-password',
  USER_DATA: '/me',
  PROFILE: '/profile',
  USER_ROUTE: '/me/permissions',
  CONVERSATIONS: '/conversations',
  AGENTS: '/agents',
  FLOW: {
    FLOW: '/flow',
    MENUENTRIES: '/flow/menu-entry',
    LANGUAGES: '/flow/languages',
    LLM_BLOCKS: '/flow/llm-blocks',
    LLM_BLOCKS_BY_COMPANY: '/flow/llm-blocks-by-company',
  },
  WEBCLIENT: '/integrations/webclient',
  FACEBOOK: 'integrations/facebook',
  COMPANY: '/companies',
  ROLE: '/roles',
  LINKS: '/links',
  MFA: '/mfa',
  EXPORTS: {
    EXPORTS: '/exports',
    CONFIG: '/config/exports',
    CONFIG_STATUS: '/config/exports/status',
  },
};
